export var APP_STATES;
(function (APP_STATES) {
    APP_STATES[APP_STATES["INIT"] = 1] = "INIT";
    APP_STATES[APP_STATES["STAKE"] = 2] = "STAKE";
    APP_STATES[APP_STATES["ACTORS"] = 3] = "ACTORS";
    APP_STATES[APP_STATES["DATAS"] = 4] = "DATAS";
    APP_STATES[APP_STATES["ACTIONS"] = 5] = "ACTIONS";
    APP_STATES[APP_STATES["QUESTIONS"] = 6] = "QUESTIONS";
    APP_STATES[APP_STATES["END"] = 7] = "END";
})(APP_STATES || (APP_STATES = {}));
